/* eslint-disable no-redeclare */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable  @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars*/
import React, { FC, useCallback, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
// import moment from 'moment';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { useSelector, useDispatch } from 'react-redux';
// import { useDispatch, useSelector } from 'react-redux';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Spinner from '@salesforce/design-system-react/components/spinner';
import Button from '@salesforce/design-system-react/components/button';
import moment from 'moment';
import CycleCountHeader from './CycleCountHeader';
import CycleCountDataTable, { CYCLE_COUNT_SORT_COLUMNS } from './CycleCountDataTable';
import { GET_CYCLE_COUNT_REQUEST_LISTS } from '../../graphql/getCycleCountRequestList';
import {
  LIMIT,
  NEXT_DATA,
  PREV_DATA,
  SHOW_STRYKER_RECORDS,
  SHOW_AGENCY_RECORDS,
} from '../../util/constants';
import debounced from '../../util/debounced';
import './index.scss';
import FilterTags from '../Shared/FilterTags';
import FilterCycleCount from './ReviewCounts/FilterCycleCount';
import { getUserInfo } from '../../store/ducks/userInfo';
import { GET_FILTER_PRESETS } from '../../graphql/getFilterPresets';
import { setHoldBannerStatus } from '../../store/ducks/holdBanner';
import {
  clearAllCycleCountFilters,
  getAllCycleCountFilters,
  setAllCycleCountFilters,
} from '../../store/ducks/cycleCountFilter';
import { readSortFromStorage } from '../../util/listSortStorage';

interface Props {
  type?: string;
}

interface SelectedData {
  id: string;
  label: string;
  number: string;
  subInventoryCode: string;
  __typename?: string;
}
interface Filters {
  status: SelectedData[];
  startDate: Date | string;
  endDate: Date | string;
  usage: string;
  eventType: string[];
  filterExternalId?: string;
  filterName?: string;
  search?: string;
}

interface DynamicValue {
  [key: string]: any;
}

const CycleCount: FC<Props> = ({ type }) => {
  const [offset, setOffset] = useState(0);
  const userInfo = useSelector(getUserInfo);
  const [cycleCounts, setCycleCounts] = useState<any[]>([]);
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [isEditFilter, setIsEditFilter] = useState(false);
  const initialCycleCountSort = readSortFromStorage('cyclecount_all', CYCLE_COUNT_SORT_COLUMNS);
  const [sortColumn, setSortColumn] = useState<any>(
    initialCycleCountSort
      ? {
          property: initialCycleCountSort.sortColumn,
          sortDirection: initialCycleCountSort.sortDirection,
        }
      : undefined
  );
  const sortColumnRef = React.useRef<any>(sortColumn);
  sortColumnRef.current = sortColumn;
  const [selectedFilter, setSelectedFilter] = useState<DynamicValue | null>(null);
  const [selectedFilterApiValues, setSelectedFilterApiValues] = useState<DynamicValue | null>(null);
  const [getCycleCounts, { data: cycleCountsList, refetch: refetchCycleCounts }] = useLazyQuery(
    GET_CYCLE_COUNT_REQUEST_LISTS,
    {
      fetchPolicy: 'cache-first',
    }
  );
  const { data: filterPresets, refetch: refetchFilterPresets } = useQuery(GET_FILTER_PRESETS, {
    variables: {
      userId: userInfo?.id,
      type: 'CycleCount',
      filterValues: {},
    },
  });
  const dispatch = useDispatch();
  dispatch(setHoldBannerStatus(false));

  useEffect(() => {
    const orderBy = sortColumnRef.current?.property;
    const orderSortType = sortColumnRef.current?.sortDirection;
    const sortVars = orderBy && orderSortType ? { orderBy, orderSortType } : {};
    getCycleCounts({
      variables: {
        limit: 50,
        offset: 0,
        ...sortVars,
        filters: selectedFilterApiValues,
      },
    });
  }, [getCycleCounts, selectedFilterApiValues, type]);

  const refetchCycleCountsList = (): void => {
    const orderBy = sortColumnRef.current?.property;
    const orderSortType = sortColumnRef.current?.sortDirection;
    const sortVars = orderBy && orderSortType ? { orderBy, orderSortType } : {};
    getCycleCounts({
      variables: {
        limit: 50,
        offset: 0,
        ...sortVars,
        filters: selectedFilterApiValues,
      },
    });
  };

  const getCycleCountList = useCallback((items: any[]): any[] => {
    if (items && items.length > 0) {
      const list = items.map((item: any) => {
        return {
          ...item,
          startDate: item.startDate ? moment.utc(item.startDate).format('L') : '--',
          endDate: item.endDate ? moment.utc(item.endDate).format('L') : '--',
          inventoryHold: item.isInventoryHold === true ? 'Yes' : 'No',
          salesRep: item.salesRep ? item.salesRep.join(', ') : null,
        };
      });
      return list;
    }
    return [];
  }, []);
  useEffect(() => {
    if (cycleCountsList?.getCycleCountRequestList) {
      const list = getCycleCountList(cycleCountsList.getCycleCountRequestList);
      setCycleCounts(list);
    }
  }, [cycleCountsList, getCycleCountList]);

  const handleRefetchItems = useCallback(
    (filterData: Filters | DynamicValue | null): void => {
      setOffset(0);
      const orderBy = sortColumnRef.current?.property;
      const orderSortType = sortColumnRef.current?.sortDirection;
      const sortVars = orderBy && orderSortType ? { orderBy, orderSortType } : {};
      getCycleCounts({
        variables: {
          offset: 0,
          limit: LIMIT,
          ...sortVars,
          filters: filterData,
        },
      });
    },
    [getCycleCounts]
  );

  const filterStore = useSelector(getAllCycleCountFilters);

  useEffect(() => {
    const setFilters = JSON.parse(filterStore || '{}');
    if (setFilters && setFilters.filterValues) {
      setSelectedFilter(setFilters);
      const filters = getFilterApiValue(setFilters.filterValues);
      setSelectedFilterApiValues(filters);
      handleRefetchItems(filters);
    }
  }, [filterStore, handleRefetchItems]);

  const handlePaginationButtonClicked = (nav: string): void => {
    let finalOffset;
    if (nav === NEXT_DATA) {
      finalOffset = offset + LIMIT;
    } else {
      finalOffset = offset - LIMIT;
    }
    if (sortColumn) {
      const sortProperty = sortColumn.property;
      const { sortDirection } = sortColumn;
      getCycleCounts({
        variables: {
          offset: finalOffset,
          limit: LIMIT,
          orderBy: sortProperty,
          orderSortType: sortDirection,
          ...(selectedFilter && { filters: getFilterApiValue(selectedFilter.filterValues) }),
        },
      });
    } else {
      getCycleCounts({
        variables: {
          offset: finalOffset,
          limit: LIMIT,
          orderBy: undefined,
          orderSortType: undefined,
          ...(selectedFilter && { filters: getFilterApiValue(selectedFilter.filterValues) }),
        },
      });
    }

    setOffset(finalOffset);
  };

  const sortCycleCountList = (data: any[]): void => {
    setCycleCounts(data);
  };
  const handleToggleFilterCycleCount = (): void => {
    handleEditFilter(false);
    setSelectedFilter(null);
    setFilterModalVisible(!filterModalVisible);
  };

  const sortedcolumn = (property: any): void => {
    setSortColumn(property);
  };

  const resetPagination = useCallback((): void => {
    setOffset(0);
  }, []);

  const filterData = filterPresets?.getFilterPresets;

  const getFilterApiValue = (filterValues: DynamicValue): DynamicValue => {
    let reducedFilterValues = {};
    if (filterValues) {
      Object.keys(filterValues).forEach((key: string) => {
        if (Array.isArray(filterValues[key])) {
          let values;
          if (key === 'inventoryLocation') {
            values = filterValues[key].map((item: SelectedData) =>
              item.label.split('-')[0]?.trim()
            );
          } else if (key === 'countType') {
            values = filterValues[key].map((item: SelectedData) => item.label);
          } else if (key === 'account') {
            values = filterValues[key].map(
              (item: SelectedData) => item?.number || item?.subInventoryCode
            );
          } else {
            values = filterValues[key].map((item: SelectedData) => item.id);
          }
          if (values && values.length > 0) {
            reducedFilterValues = { ...reducedFilterValues, [key]: [...values] };
          }
        } else if (key !== '__typename' && filterValues[key]) {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] };
        } else if (key === SHOW_AGENCY_RECORDS || key === SHOW_STRYKER_RECORDS) {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] || false };
        }
      });
      const filterData = { ...reducedFilterValues };
      return filterData;
    }
    return {};
  };
  const handleFilterCycleCount = (filterValues: DynamicValue | null, filterName?: string): void => {
    const updatedFilterName = filterName || '';
    const filter = {
      filterValues,
      filterName: updatedFilterName,
    };
    setSelectedFilter(filter);
    if (filterValues) {
      const filters = getFilterApiValue(filterValues);
      setSelectedFilterApiValues(filters);
      dispatch(setAllCycleCountFilters(JSON.stringify(filter)));
      handleRefetchItems(filters);
    } else {
      resetFilters();
    }
  };

  const setRequestSearch = (searchedItem: string): void => {
    const orderBy = sortColumnRef.current?.property;
    const orderSortType = sortColumnRef.current?.sortDirection;
    const sortVars = orderBy && orderSortType ? { orderBy, orderSortType } : {};
    getCycleCounts({
      variables: {
        offset: 0,
        limit: LIMIT,
        ...sortVars,
        filters: {
          searchText: searchedItem,
        },
      },
    });
  };

  const debouncedFetchRequestedItems = useCallback(debounced(500, setRequestSearch), [
    debounced,
    setRequestSearch,
  ]);

  const handleCycleCountSearch = useCallback(
    (_event: { persist: () => void }, searchedItem: any) => {
      const { value } = searchedItem;
      _event.persist();
      if (value && value.length >= 3) {
        debouncedFetchRequestedItems(value);
      } else {
        debouncedFetchRequestedItems(value);
      }
    },
    [debouncedFetchRequestedItems]
  );

  const resetFilters = useCallback((): void => {
    dispatch(clearAllCycleCountFilters());
    setSelectedFilter(null);
    setIsEditFilter(false);
    setSelectedFilterApiValues(null);
    setOffset(0);
    const orderBy = sortColumnRef.current?.property;
    const orderSortType = sortColumnRef.current?.sortDirection;
    const sortVars = orderBy && orderSortType ? { orderBy, orderSortType } : {};
    getCycleCounts({
      variables: {
        offset: 0,
        limit: LIMIT,
        ...sortVars,
      },
    });
  }, [dispatch, getCycleCounts]);

  const handleEditPress = (filter: any, isEditPress: boolean): void => {
    setSelectedFilter(filter);
    setFilterModalVisible(!filterModalVisible);
    if (isEditPress) {
      handleEditFilter(true);
    }
  };

  const handleEditFilter = (editFilter: boolean): void => {
    setIsEditFilter(editFilter);
  };
  const handleDeleteFilterPreset = (externalId: string): void => {
    const filterExternalId = selectedFilter ? selectedFilter.filterExternalId : null;
    if (filterExternalId && filterExternalId === externalId) {
      resetFilters();
    }
  };
  return (
    <div className="slds-p-horizontal_large slds-p-vertical_x-large events_list">
      <IconSettings iconPath="/icons">
        {filterModalVisible && (
          <FilterCycleCount
            handleToggleFilterCycleCount={handleToggleFilterCycleCount}
            filterModalVisible={filterModalVisible}
            selectedFilter={selectedFilter}
            handleFilterCycleCount={handleFilterCycleCount}
            resetFilters={resetFilters}
            handleEditFilter={handleEditFilter}
            handleClearFilter={handleDeleteFilterPreset}
            refetchFilterPresets={refetchFilterPresets}
            isEditFilter={isEditFilter}
          />
        )}
        <CycleCountHeader
          cycleCount={cycleCounts?.length}
          selectedFilterApiValues={selectedFilterApiValues}
          label=""
          handleToggleFilterCycleCount={handleToggleFilterCycleCount}
          handleCycleCountSearch={handleCycleCountSearch}
          refetchCycleCounts={refetchCycleCountsList}
          resetFilters={resetFilters}
          type=""
          onEditPress={handleEditPress}
          filterPresets={filterData}
          handleFilterEvents={handleFilterCycleCount}
        />
        {selectedFilter && selectedFilter.filterValues && !isEditFilter && (
          <FilterTags selectedFilter={selectedFilter} handleFilter={handleFilterCycleCount} />
        )}
        <div className="order-list-container">
          {!cycleCountsList && (
            <Spinner
              size="large"
              variant="base"
              assistiveText={{ label: 'Loading...' }}
              key="spinner"
            />
          )}
          <CycleCountDataTable
            cycleCounts={cycleCountsList?.getCycleCountRequestList === null ? [] : cycleCounts}
            sortCycleCountList={sortCycleCountList}
            sortedcolumn={sortedcolumn}
            resetPagination={resetPagination}
            getCycleCounts={getCycleCounts}
            // refetch={refetchCycleCounts}
            selectedFilterApiValues={selectedFilterApiValues}
            type=""
          />
        </div>
        <div className="slds-grid slds-grid_align-center slds-grid_vertical-align-center slds-p-top_medium">
          <div className="slds-col">
            <Button
              assistiveText={{ icon: 'Icon Bare Small' }}
              iconCategory="utility"
              iconName="chevronleft"
              iconSize="small"
              disabled={!(offset > 0)}
              iconVariant="bare"
              onClick={(): void => handlePaginationButtonClicked(PREV_DATA)}
              variant="icon"
            />
          </div>
          <div className="slds-col slds-p-left_medium slds-p-right_medium">
            <span>{`${offset + 1} - ${offset + LIMIT}`}</span>
          </div>
          <div className="slds-col">
            {cycleCountsList?.getCycleCountRequestList === null ? (
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronright"
                iconSize="small"
                iconVariant="bare"
                disabled
                variant="icon"
              />
            ) : (
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronright"
                iconSize="small"
                iconVariant="bare"
                disabled={
                  cycleCountsList &&
                  cycleCountsList?.getCycleCountRequestList.length &&
                  cycleCountsList?.getCycleCountRequestList.length < 50
                }
                onClick={(): void => handlePaginationButtonClicked(NEXT_DATA)}
                variant="icon"
              />
            )}
          </div>
        </div>
      </IconSettings>
    </div>
  );
};

export default CycleCount;
